import { type ForwardedRef, forwardRef, useEffect, useState } from 'react';

import { SWITCH_DEFAULT_SIZE } from './constant';
import style from './style';
import type { VSwitchProps } from './type';

const VSwitch = forwardRef(
  (props: VSwitchProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
      checked,
      onChange,
      disabled = false,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      size = SWITCH_DEFAULT_SIZE,
      ...buttonProps
    } = props;

    const [innerChecked, setInnerChecked] = useState(checked ?? false);
    const currentChecked = checked !== undefined ? checked : innerChecked;

    const handleClick = () => {
      if (disabled) return;

      setInnerChecked(!innerChecked);
    };

    useEffect(() => {
      if (checked === innerChecked) return;

      onChange?.(innerChecked);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [innerChecked]);

    useEffect(() => {
      if (checked === innerChecked) return;

      setInnerChecked(!!checked);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked]);

    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={currentChecked}
        disabled={disabled}
        className={style.switch(currentChecked)}
        onClick={handleClick}
        {...buttonProps}
      >
        <div className={style.contentContainer()}>
          <span className={style.thumb(currentChecked, disabled)} />
          <div className={style.text(currentChecked, disabled)}>
            {currentChecked ? 'ON' : 'OFF'}
          </div>
        </div>
      </button>
    );
  },
);

export default VSwitch;
